export default __webpack_public_path__ + "static/media/logoComin.739a4ff9.png";